import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["options", "label", "displayValue", "wrapperStyle", "onSelect", "onRemove"];
import React from 'react';
import { array, bool, string, func, number, object } from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@mch-group/uikit-components';
import Multiselect from 'multiselect-react-dropdown';

var CMultiSelect = function CMultiSelect(_ref) {
  var options = _ref.options,
      label = _ref.label,
      _ref$displayValue = _ref.displayValue,
      displayValue = _ref$displayValue === void 0 ? 'text' : _ref$displayValue,
      wrapperStyle = _ref.wrapperStyle,
      onSelect = _ref.onSelect,
      onRemove = _ref.onRemove,
      props = _objectWithoutProperties(_ref, _excluded);

  var combinedStyle = _objectSpread({
    borderBottom: '1px solid #ccc'
  }, wrapperStyle);

  return /*#__PURE__*/React.createElement(Wrapper, {
    style: combinedStyle
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "fw-bold"
  }, label), /*#__PURE__*/React.createElement(Multiselect, _extends({
    options: options || [] // Options to display in the dropdown
    ,
    displayValue: displayValue,
    onSelect: onSelect // Function will trigger on select event
    ,
    onRemove: onRemove // Function will trigger on remove event
    ,
    avoidHighlightFirstOption: true // eslint-disable-next-line no-unused-vars
    ,
    optionValueDecorator: function optionValueDecorator(v, _option) {
      return /*#__PURE__*/React.createElement(DropDownOption, {
        className: "p-3 w-100"
      }, /*#__PURE__*/React.createElement("p", {
        className: "p-0 m-0"
      }, v));
    },
    customCloseIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      color: "#ccc",
      size: 18,
      className: "ms-3"
    }),
    style: {
      chips: {
        background: '#ececec',
        color: 'black',
        borderRadius: '5px',
        padding: '5px'
      },
      option: {
        display: 'flex',
        backgroundColor: 'transparent',
        color: 'black',
        flexDirection: 'row'
      },
      searchBox: {
        border: 0,
        padding: 0
      },
      optionContainer: {
        backgroundColor: 'white',
        zIndex: 3
      },
      optionListContainer: {
        zIndex: 3
      }
    }
  }, props)));
};

var Wrapper = styled.div.withConfig({
  displayName: "CMultiSelect__Wrapper",
  componentId: "sc-4491n2-0"
})([".multiSelectContainer li{padding:5px 10px;width:'100%';}.optionListContainer{z-index:3 !important;}"]);
var DropDownOption = styled.div.withConfig({
  displayName: "CMultiSelect__DropDownOption",
  componentId: "sc-4491n2-1"
})(["&:hover{background-color:#ececec;}padding:0px;border-radius:5px;"]);
CMultiSelect.propTypes = {
  id: string,
  options: array,
  label: string,
  placeholder: string,
  displayValue: string,
  singleSelect: bool,
  selectedValues: array,
  showCheckbox: bool,
  isObject: bool,
  caseSensitiveSearch: bool,
  emptyRecordMsg: string,
  groupBy: string,
  closeIcon: string,
  className: string,
  style: object,
  disablePreSelectedValues: bool,
  closeOnSelect: bool,
  avoidHighlightFirstOption: bool,
  hidePlaceholder: bool,
  disable: bool,
  loading: bool,
  showArrow: bool,
  keepSearchTerm: bool,
  selectionLimit: number,
  onSelect: func.isRequired,
  onRemove: func.isRequired,
  onSearch: func,
  loadingMessage: string,
  wrapperStyle: object
};
export default CMultiSelect;